/* Nachtzijde — theme behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  var T = window.theme || {};
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  /* Disable prev/next at the ends of a row. A disabled button drops keyboard
     focus to <body>, so a focused arrow first hands focus to the other one. */
  function setArrowState(prev, next, prevOff, nextOff) {
    if (prev && prevOff && prev === document.activeElement && next && !nextOff) next.focus({ preventScroll: true });
    if (next && nextOff && next === document.activeElement && prev && !prevOff) prev.focus({ preventScroll: true });
    if (prev) prev.disabled = prevOff;
    if (next) next.disabled = nextOff;
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    if (fmt.indexOf('comma_separator') !== -1) {
      value = value.replace('.', ',');
      value = value.replace(/\B(?=(\d{3})+(?!\d)(?=,))/g, '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------------- Body scroll lock ---------------- */
  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.classList.add('is-locked'); }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }

  /* ---------------- Overlay ---------------- */
  function overlay() {
    var el = $('[data-overlay]');
    if (!el) { el = document.createElement('div'); el.className = 'overlay'; el.setAttribute('data-overlay', ''); document.body.appendChild(el); }
    return el;
  }

  /* ---------------- Generic panel (drawer/menu) ---------------- */
  var openPanels = [];
  /* An open drawer is modal: everything outside it goes inert, so Tab cannot
     wander into the page underneath. */
  function setPageInert(panel, inert) {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (inert) {
        if (el.contains(panel) || el.hasAttribute('data-overlay') || el.inert) return;
        el.inert = true; el.__nzInert = true;
      } else if (el.__nzInert) {
        el.inert = false; el.__nzInert = false;
      }
    });
  }
  function openPanel(panel, focusTarget) {
    if (!panel || panel.classList.contains('is-open')) return;
    setPageInert(panel, true);
    panel.classList.add('is-open');
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    overlay().classList.add('is-open');
    lockScroll();
    openPanels.push(panel);
    var f = focusTarget || panel.querySelector('[data-panel-close]') || panel;
    window.setTimeout(function () { try { f.focus(); } catch (e) {} }, 60);
  }
  function closePanel(panel) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== panel; });
    if (!openPanels.length) { overlay().classList.remove('is-open'); setPageInert(panel, false); }
    unlockScroll();
    var opener = panel.__opener;
    if (opener) { try { opener.focus(); } catch (e) {} }
  }
  function closeAllPanels() { openPanels.slice().forEach(closePanel); }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-panel-open]');
    if (openBtn) {
      var target = document.getElementById(openBtn.getAttribute('data-panel-open'));
      if (target) { e.preventDefault(); target.__opener = openBtn; openPanel(target); }
      return;
    }
    var closeBtn = e.target.closest('[data-panel-close]');
    if (closeBtn) { e.preventDefault(); closePanel(closeBtn.closest('[data-panel]')); return; }
    if (e.target.hasAttribute && e.target.hasAttribute('data-overlay')) closeAllPanels();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanels.length) closePanel(openPanels[openPanels.length - 1]);
  });

  /* ---------------- Delivery line in the buy box ---------------- */
  /* Free delivery from a threshold: the line follows the total being bought. */
  function setShipLine(cents) {
    var el = $('[data-ship-line]');
    if (!el || isNaN(cents)) return;
    var th = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    var txt = $('[data-ship-text]', el);
    if (txt) txt.textContent = el.getAttribute(th === 0 || cents >= th ? 'data-free' : 'data-from');
  }

  /* ---------------- Cart ---------------- */
  var Cart = {
    sectionsToRender: function () {
      var ids = [];
      if ($('#CartDrawer')) ids.push('cart-drawer');
      if ($('[data-cart-count]')) ids.push('header');
      if ($('#MainCart')) ids.push('main-cart');
      return ids;
    },

    add: function (formData, button) {
      var ids = this.sectionsToRender();
      formData.append('sections', ids.join(','));
      formData.append('sections_url', window.location.pathname);
      if (button) button.classList.add('loading');

      return fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || T.strings.cartError);
          Cart.renderSections(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          var drawer = $('#CartDrawer');
          if (drawer && drawer.dataset.enabled === 'true') {
            drawer.__opener = Cart.opener || button;
            openPanel(drawer);
          }
          return data;
        })
        .catch(function (err) {
          Cart.showError(button, err.message || T.strings.cartError);
        })
        .finally(function () { if (button) button.classList.remove('loading'); });
    },

    change: function (line, quantity) {
      var ids = this.sectionsToRender();
      return fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line, quantity: quantity, sections: ids, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          Cart.renderSections(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          var status = $('[data-cart-status]');
          if (status && typeof data.item_count === 'number') {
            status.textContent = (T.strings.cartUpdated || '').replace('[count]', data.item_count);
          }
          return data;
        });
    },

    renderSections: function (sections) {
      if (!sections) return;
      /* Remember which cart control had focus, to put it back after the swap. */
      var a = document.activeElement, host = a && a.closest ? a.closest('[data-section-root]') : null, sel = null;
      if (host && a.hasAttribute('data-line-qty')) {
        sel = '[data-line-qty="' + a.getAttribute('data-line-qty') + '"][data-dir="' + a.getAttribute('data-dir') + '"]';
      } else if (host && a.hasAttribute('data-line-remove')) {
        sel = '[data-line-remove], [data-panel-close]';
      }
      var hostId = host && host.getAttribute('data-section-root');
      Object.keys(sections).forEach(function (id) {
        var html = new DOMParser().parseFromString(sections[id], 'text/html');
        var incoming = html.querySelector('[data-section-root="' + id + '"]');
        var current = $('[data-section-root="' + id + '"]');
        if (!incoming || !current) return;
        /* The drawer node itself stays: replacing it would drop its open state
           while the overlay and scroll lock stayed on. Only its contents change. */
        var live = id === 'cart-drawer' && $('#CartDrawer', current);
        var fresh = live && incoming.querySelector('#CartDrawer');
        if (live && fresh) {
          live.innerHTML = fresh.innerHTML;
          live.setAttribute('data-enabled', fresh.getAttribute('data-enabled') || '');
        } else {
          current.innerHTML = incoming.innerHTML;
        }
      });
      initAll();
      if (sel && hostId) {
        var back = $(sel, $('[data-section-root="' + hostId + '"]'));
        if (back) { try { back.focus(); } catch (e) {} }
      }
    },

    showError: function (button, message) {
      var host = button ? button.closest('form') || button.parentElement : document.body;
      var note = host.querySelector('[data-cart-error]');
      if (!note) {
        note = document.createElement('p');
        note.className = 'form-note form-note--error';
        note.setAttribute('data-cart-error', '');
        host.appendChild(note);
      }
      note.textContent = message;
      window.setTimeout(function () { if (note.parentElement) note.remove(); }, 6000);
    }
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    /* A second tap while the first add is still running would add twice. */
    if (btn && btn.classList.contains('loading')) return;
    Cart.opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : btn;
    var fd = new FormData(form);
    /* Only the product page's own form takes the ticked add-on along, not the
       drawer's or a card's quick add. Both lines go in one request.
       (form.id would return the form's name="id" input, hence getAttribute.) */
    var extras = [];
    if (form.getAttribute('id') === 'ProductForm') {
      $$('[data-addon-box]').forEach(function (b) { if (b.__addonItems) extras = extras.concat(b.__addonItems()); });
    }
    if (extras.length && fd.get('id')) {
      var items = new FormData();
      items.append('items[0][id]', fd.get('id'));
      items.append('items[0][quantity]', fd.get('quantity') || '1');
      extras.forEach(function (x, n) {
        items.append('items[' + (n + 1) + '][id]', x.id);
        items.append('items[' + (n + 1) + '][quantity]', String(x.quantity || 1));
      });
      fd = items;
    }
    Cart.add(fd, btn);
  });

  /* Cart +/- counts from the number on screen and sends changes one after
     another, so two quick taps (2 -> 4, the "3 + 1" tier) both land. */
  /* A line's latest wanted quantity while its changes are still queued: a
     re-render in between shows the server's older number, so taps count from this. */
  var cartQueue = Promise.resolve(), cartPending = {}, cartSeq = 0;
  function queueCartChange(line, qty) {
    var seq = ++cartSeq;
    cartPending[line] = { to: qty, seq: seq };
    cartQueue = cartQueue.then(function () { return Cart.change(line, qty); })
      .catch(function () { return null; })
      .then(function () { if (cartPending[line] && cartPending[line].seq === seq) delete cartPending[line]; });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      rm.getAttribute('data-line-remove').split(',').forEach(function (key) { if (key) queueCartChange(key, 0); });
      return;
    }
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      e.preventDefault();
      var line = q.getAttribute('data-line-qty');
      /* The row's other lines: its +/- change the last line, by the row's count. */
      var offset = parseInt(q.getAttribute('data-line-offset'), 10) || 0;
      var input = $('input', q.closest('[data-cart-qty]') || q.parentElement);
      var next = parseInt(q.getAttribute('data-line-to'), 10);
      if (input) {
        var base = cartPending[line] ? cartPending[line].to + offset : (parseInt(input.value, 10) || 0);
        var want = Math.max(offset, base + (parseInt(q.getAttribute('data-dir'), 10) || 0));
        if (want === base) return;
        input.value = want;
        next = want - offset;
      }
      queueCartChange(line, next);
    }
  });

  /* ---------------- Quantity widget ---------------- */
  function initQty(root) {
    $$('[data-qty]', root).forEach(function (w) {
      if (w.__init) return; w.__init = true;
      var input = $('input', w);
      $$('button', w).forEach(function (b) {
        on(b, 'click', function () {
          var step = b.getAttribute('data-qty-step') === 'down' ? -1 : 1;
          var next = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Variant picker ---------------- */
  /* Shopify resolves a variant from ?variant=<id>, not from option names, so the
     match is done here against the variant table the section embeds. Price, the
     buy button and the gallery all update without a round trip. */
  function initVariantPicker(root) {
    $$('[data-variant-picker]', root).forEach(function (picker) {
      if (picker.__init) return; picker.__init = true;

      var holder = picker.parentElement.querySelector('[data-variant-data]');
      var variants = [];
      if (holder) {
        try { variants = JSON.parse(holder.textContent); } catch (e) { variants = []; }
      }
      var productUrl = picker.getAttribute('data-url');
      var scope = picker.closest('[data-section-root]') || document;

      function selectedValues() {
        return $$('input:checked', picker).map(function (i) { return i.value; });
      }

      function match(values) {
        for (var i = 0; i < variants.length; i++) {
          var o = variants[i].options || [];
          var same = o.length === values.length;
          for (var j = 0; same && j < values.length; j++) {
            if (o[j] !== values[j]) same = false;
          }
          if (same) return variants[i];
        }
        return null;
      }

      function apply(v) {
        if (!v) return;

        var idInput = $('[name="id"]', scope);
        if (idInput) idInput.value = v.id;

        var label = $('[data-option-selected]', picker);
        if (label) label.textContent = selectedValues()[0] || label.textContent;

        var priceBox = $('[data-price]', scope);
        if (priceBox) {
          var cur = $('[data-price-current]', priceBox);
          var cmp = $('[data-price-compare]', priceBox);
          var badge = $('[data-price-badge]', priceBox);
          if (cur) cur.textContent = v.priceText;
          var onSale = v.compare > v.price;
          if (cmp) { cmp.textContent = v.compareText; cmp.hidden = !onSale; }
          if (badge) {
            badge.hidden = !onSale;
            if (onSale) {
              badge.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
            }
          }
        }

        var forced = document.documentElement.getAttribute('data-force-available') === 'true';
        var buyable = v.available || forced;
        $$('[data-buy-buttons] button[type="submit"], [data-sticky-submit]', document).forEach(function (btn) {
          btn.disabled = !buyable;
          btn.textContent = buyable
            ? (T.strings.addToCart + ' – ' + v.priceText)
            : T.strings.soldOut;
        });

        selectGallerySlide(v.media);

        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) {}

        /* Let other buy-box parts (quantity breaks) follow the new colour. */
        var qtyEl = $('[data-buy-buttons] input[name="quantity"]');
        setShipLine((+v.price || 0) * ((qtyEl && parseInt(qtyEl.value, 10)) || 1));
        document.dispatchEvent(new CustomEvent('nz:variant-change', { detail: { variant: v } }));
      }

      picker.addEventListener('change', function () {
        apply(match(selectedValues()));
      });
    });
  }

  function selectGallerySlide(index) {
    var track = $('[data-gallery-track]');
    if (!track || isNaN(index)) return;
    var slide = track.children[index];
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
    syncThumbs(index);
  }

  function syncThumbs(index) {
    $$('[data-gallery-thumb]').forEach(function (t, i) {
      var active = i === index;
      t.classList.toggle('is-active', active);
      if (active && t.parentElement) {
        var strip = t.parentElement;
        var left = t.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left - 8, behavior: RM.matches ? 'auto' : 'smooth' });
        }
      }
    });
    $$('[data-gallery-dot]').forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
  }

  /* ---------------- Gallery ---------------- */
  /* Full-screen photo view: the zoom button or a tap on a photo opens it; arrows,
     swipe and the arrow keys move through the photos; Escape closes (native dialog). */
  function initLightbox(root, track, goTo) {
    var scope = (root && root.closest && root.closest('[data-section-root]')) || document;
    var box = $('[data-lightbox]', scope);
    var zoom = $('[data-gallery-zoom]', scope);
    if (!box || !box.showModal) return;
    var img = $('[data-lightbox-img]', box), count = $('[data-lightbox-count]', box);
    var index = 0, opener = null;
    function photos() { return $$('.gallery__slide img', track); }
    function big(src) { return src.replace(/([?&])width=\d+/, '$1width=2000'); }
    function show(i) {
      var list = photos(); if (!list.length) return;
      index = (i + list.length) % list.length;
      var p = list[index];
      img.src = big(p.currentSrc || p.src);
      img.alt = p.alt || '';
      if (count) count.textContent = (index + 1) + ' / ' + list.length;
    }
    function open(i, from) {
      opener = from || document.activeElement;
      show(i);
      box.showModal();
    }
    on(zoom, 'click', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      var slide = $$('.gallery__slide', track)[i];
      var p = slide && $('img', slide);
      open(p ? photos().indexOf(p) : 0, zoom);
    });
    on(track, 'click', function (e) {
      var p = e.target.closest('.gallery__slide img');
      if (p) open(photos().indexOf(p), p);
    });
    $$('[data-lightbox-nav]', box).forEach(function (b) {
      on(b, 'click', function () { show(index + parseInt(b.getAttribute('data-lightbox-nav'), 10)); });
    });
    on($('[data-lightbox-close]', box), 'click', function () { box.close(); });
    on(box, 'click', function (e) { if (e.target === box) box.close(); });
    on(box, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
    var x0 = null;
    on(box, 'touchstart', function (e) { x0 = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    on(box, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
    });
    on(box, 'close', function () {
      /* Leave the page gallery on the photo the shopper ended on. */
      var p = photos()[index], slides = $$('.gallery__slide', track);
      var at = p ? slides.indexOf(p.closest('.gallery__slide')) : -1;
      if (at >= 0) goTo(at);
      if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (err) {} }
    });
  }

  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track || track.__init) return; track.__init = true;

    function slides() { return $$('.gallery__slide', track); }
    function currentIndex() { return Math.round(track.scrollLeft / track.clientWidth); }

    function goTo(i) {
      var list = slides();
      var n = Math.max(0, Math.min(list.length - 1, i));
      var slide = list[n];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
      /* Mark the target right away: the scroll listener below also syncs, but a
         smooth scroll can be throttled and the highlight must not lag behind. */
      syncThumbs(n);
      setArrows(n, list.length);
    }

    function setArrows(i, total) {
      var prev = $('[data-gallery-arrow="prev"]', root);
      var next = $('[data-gallery-arrow="next"]', root);
      setArrowState(prev, next, i <= 0, i >= total - 1);
    }

    $$('[data-gallery-thumb]').forEach(function (thumb, i) {
      on(thumb, 'click', function () { goTo(i); });
    });

    $$('[data-gallery-arrow]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        goTo(currentIndex() + (btn.getAttribute('data-gallery-arrow') === 'prev' ? -1 : 1));
      });
    });

    on(track, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
    });

    var ticking = false;
    on(track, 'scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () {
        var i = currentIndex();
        syncThumbs(i);
        setArrows(i, slides().length);
        ticking = false;
      });
    });

    var prev0 = $('[data-gallery-arrow="prev"]', root);
    if (prev0) prev0.disabled = true;

    initLightbox(track.closest('[data-gallery]') || root, track, goTo);

    /* A colour card links to ?variant=<id>; the server marks that variant's photo,
       so start the gallery there instead of on the first colour. */
    var startEl = $('[data-variant-media-index]', track.closest('[data-gallery]') || root);
    var start = startEl ? parseInt(startEl.getAttribute('data-variant-media-index'), 10) : 0;
    if (start > 0) {
      var jump = function () {
        var slide = slides()[start];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'auto' });
        syncThumbs(start);
        setArrows(start, slides().length);
      };
      jump();
      window.requestAnimationFrame(jump);
    }

    $$('[data-video-play]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var wrap = btn.closest('[data-video-wrap]');
        var video = $('video', wrap);
        if (video) { video.controls = true; video.play(); btn.remove(); }
      });
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (tabs) {
      if (tabs.__init) return; tabs.__init = true;
      var buttons = $$('[role="tab"]', tabs);
      var panels = $$('[role="tabpanel"]', tabs);
      var media = $$('[data-tab-media]', tabs);
      function select(i) {
        buttons.forEach(function (b, bi) { b.setAttribute('aria-selected', bi === i ? 'true' : 'false'); b.tabIndex = bi === i ? 0 : -1; });
        panels.forEach(function (p, pi) { if (pi === i) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
        media.forEach(function (m, mi) { if (mi === i) m.removeAttribute('hidden'); else m.setAttribute('hidden', ''); });
      }
      buttons.forEach(function (b, i) {
        on(b, 'click', function () { select(i); });
        on(b, 'keydown', function (e) {
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          var t = (next + buttons.length) % buttons.length;
          buttons[t].focus(); select(t);
        });
      });
      select(0);
    });
  }

  /* ---------------- Text rotator ---------------- */
  function initRotator(root) {
    $$('[data-rotator]', root).forEach(function (r) {
      if (r.__init) return; r.__init = true;
      var items = $$('.rotator__item', r);
      if (items.length < 2) return;
      var i = 0;
      items[0].classList.add('is-active');
      if (RM.matches) return;
      window.setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, parseInt(r.getAttribute('data-interval'), 10) || 2600);
    });
  }

  /* ---------------- Announcement rotator ---------------- */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar.__init) return; bar.__init = true;
      var items = $$('.announcement__item', bar);
      if (!items.length) return;
      var i = 0, timer = null;
      function show(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      items[0].classList.add('is-active');
      var held = false, stopped = false;
      on($('[data-announcement-prev]', bar), 'click', function () { stopped = true; show(i - 1); restart(); });
      on($('[data-announcement-next]', bar), 'click', function () { stopped = true; show(i + 1); restart(); });
      function restart() {
        window.clearInterval(timer);
        if (items.length > 1 && !RM.matches && !held && !stopped) timer = window.setInterval(function () { show(i + 1); }, 4200);
      }
      /* Pauses while hovered or focused; stops once someone uses the arrows. */
      on(bar, 'mouseenter', function () { held = true; restart(); });
      on(bar, 'mouseleave', function () { held = false; restart(); });
      on(bar, 'focusin', function () { held = true; restart(); });
      on(bar, 'focusout', function () { held = false; restart(); });
      restart();
    });
  }

  /* ---------------- Review strip: arrow paging ---------------- */
  function initReviewStrip(root) {
    $$('[data-rstrip]', root).forEach(function (strip) {
      if (strip.__init) return; strip.__init = true;
      var track = $('[data-rstrip-track]', strip);
      if (!track) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      $$('[data-rstrip-nav]', strip).forEach(function (btn) {
        on(btn, 'click', function () {
          var dir = btn.getAttribute('data-rstrip-nav') === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * step(), behavior: RM.matches ? 'auto' : 'smooth' });
        });
      });

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        setArrowState($('[data-rstrip-nav="prev"]', strip), $('[data-rstrip-nav="next"]', strip),
          track.scrollLeft <= 2, track.scrollLeft >= max);
      }
      on(track, 'scroll', sync);
      on(window, 'resize', sync);
      sync();
    });
  }

  /* ---------------- Article contents rail ---------------- */
  function initToc(root) {
    $$('[data-article]', root).forEach(function (wrap) {
      if (wrap.__init) return; wrap.__init = true;
      var body = $('[data-article-body]', wrap);
      var nav = $('[data-toc]', wrap);
      var list = $('[data-toc-list]', wrap);
      if (!body || !nav || !list) return;

      var heads = $$('h2, h3', body);
      if (heads.length < 3) return;

      var links = [];
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'sec-' + (i + 1);
        var li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'toc__item--sub';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = (h.textContent || '').trim();
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });
      nav.removeAttribute('hidden');

      /* Highlight the section the reader is in. */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = heads.indexOf(entry.target);
          if (i < 0) return;
          links.forEach(function (a, ai) { a.classList.toggle('is-current', ai === i); });
        });
      }, { rootMargin: '-80px 0px -75% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    });
  }

  /* ---------------- Selling market ----------------
     The shop only delivers to one country, but Shopify files a visitor under
     the market of the country they browse from, and outside the delivery
     country every product reads as sold out. Switch the visitor to the selling
     market once per session; checkout still only accepts addresses there. */
  function lockMarket() {
    var want = T.sellCountry;
    if (!want || !T.country || T.country === want) return;
    var key = 'nz-market-switch';
    try {
      if (window.sessionStorage.getItem(key)) return; /* already tried: never loop */
      window.sessionStorage.setItem(key, '1');
      if (window.location.hash) window.sessionStorage.setItem(key + '-hash', window.location.hash);
    } catch (e) { return; } /* no storage, no guard against a loop: leave it */

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.hidden = true;
    [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'put'],
     ['country_code', want], ['return_to', window.location.pathname + window.location.search]]
      .forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = pair[0]; input.value = pair[1];
        form.appendChild(input);
      });
    document.body.appendChild(form);
    form.submit();
  }

  /* After the switch reloads the page, put back the anchor the visitor came for. */
  function restoreMarketHash() {
    try {
      var k = 'nz-market-switch-hash';
      var h = window.sessionStorage.getItem(k);
      if (!h) return;
      window.sessionStorage.removeItem(k);
      if (!window.location.hash) window.location.hash = h;
    } catch (e) {}
  }

  /* ---------------- Swipe-row progress bar ----------------
     A thin rail under a horizontal row shows how far along it you are,
     as the reference does in place of arrows on a phone. */
  function initProgress(root) {
    $$('[data-progress]', root).forEach(function (track) {
      if (track.__progress) return;
      var bar = document.createElement('div');
      bar.className = 'swipebar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      var host = track.getAttribute('data-progress') === 'parent' ? track.parentElement : track;
      host.insertAdjacentElement('afterend', bar);
      track.__progress = bar;
      var thumb = bar.firstChild;

      function paint() {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) { bar.hidden = true; return; }
        bar.hidden = false;
        var share = track.clientWidth / track.scrollWidth;
        thumb.style.width = (share * 100) + '%';
        thumb.style.transform = 'translateX(' + (track.scrollLeft / max * (1 / share - 1) * 100) + '%)';
      }
      on(track, 'scroll', function () { window.requestAnimationFrame(paint); });
      on(window, 'resize', paint);
      paint();
      window.setTimeout(paint, 600);
    });
  }

  /* Benefit tabs: on a phone the copy folds under a "read more" toggle that lays
     it over the photo. Picking another tab folds it again, as on the reference. */
  function initTabMore(root) {
    $$('[data-btabs-more]', root).forEach(function (btn) {
      if (btn.__init) return; btn.__init = true;
      var box = btn.closest('.btabs');
      var label = $('[data-more-label]', btn);
      var more = label ? label.textContent : '';
      function set(open) {
        box.classList.toggle('is-expanded', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? (T.strings && T.strings.showLess || 'Minder') : more;
      }
      on(btn, 'click', function () { set(!box.classList.contains('is-expanded')); });
      $$('[role="tab"]', box).forEach(function (tab) {
        on(tab, 'click', function () { if (box.classList.contains('is-expanded')) set(false); });
      });
    });
  }

  /* ---------------- Quantity breaks ---------------- */
  /* The chosen card sets the quantity the buy form adds; its total goes on the
     add-to-cart buttons. A colour change swaps the photos and prices. */
  function initQtyBreaks(root) {
    $$('[data-qbreaks]', root).forEach(function (box) {
      if (box.__init) return; box.__init = true;
      var data = {};
      try { data = JSON.parse(($('[data-qbreaks-data]', box) || {}).textContent || '{}'); } catch (e) {}
      var radios = $$('input[type="radio"]', box);
      var form = $('[data-buy-buttons] form') || document;
      var qtyInput = $('input[name="quantity"]', form);
      var variantId = (($('[data-buy-buttons] [name="id"]') || {}).value) || '';

      function current() {
        for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
        return radios[0];
      }
      function tiersFor(id) { return (data[id] && data[id].tiers) || []; }
      function labelButtons() {
        var r = current(); if (!r) return;
        var t = tiersFor(variantId)[+r.getAttribute('data-qbreak-index')];
        if (!t) return;
        $$('[data-buy-buttons] button[type="submit"], [data-sticky-submit]', document).forEach(function (btn) {
          if (!btn.disabled) btn.textContent = T.strings.addToCart + ' \u2013 ' + t.total;
        });
        /* The sticky bar's price reads per piece, with the count when it is a pack. */
        var sp = $('[data-sticky-bar] [data-price-current]');
        if (sp) sp.textContent = (t.qty > 1 ? t.qty + ' \u00d7 ' : '') + t.unit;
        /* A ticked add-on puts its own price on top of this total. */
        box.__total = +t.cents; box.__saving = +t.saving || 0;
        setShipLine(box.__total);
        document.dispatchEvent(new CustomEvent('nz:base-total', { detail: { cents: box.__total, saving: box.__saving } }));
      }
      function select() {
        var r = current();
        if (r && !r.checked) r.checked = true;
        radios.forEach(function (x) { x.closest('.qbreak').classList.toggle('is-selected', x === r); });
        if (qtyInput && r) qtyInput.value = r.value;
        labelButtons();
      }
      function paint(id) {
        var d = data[id]; if (!d) return;
        radios.forEach(function (r) {
          var card = r.closest('.qbreak');
          var t = d.tiers[+r.getAttribute('data-qbreak-index')];
          if (!t) return;
          var total = $('[data-qbreak-total]', card), unit = $('[data-qbreak-unit]', card);
          if (total) total.textContent = t.total;
          if (unit) unit.textContent = t.unit;
          $$('.qbreak__img', card).forEach(function (img) {
            if (d.img) { img.removeAttribute('srcset'); img.src = d.img; }
          });
        });
      }
      radios.forEach(function (r) { on(r, 'change', select); });
      function onVariant(e) {
        /* A block removed or reloaded in the theme editor stops listening. */
        if (!box.isConnected) { document.removeEventListener('nz:variant-change', onVariant); return; }
        var v = e.detail && e.detail.variant; if (!v) return;
        variantId = String(v.id);
        paint(variantId);
        labelButtons();
      }
      document.addEventListener('nz:variant-change', onVariant);
      select();
    });
  }

  /* ---------------- Add-on ("Combineer en bespaar") ---------------- */
  /* A ticked add-on rides along with the main add-to-cart button; the buttons
     then show both prices together. Picking a colour ticks it.
     The combo saving does not stack with the quantity-break discounts: Shopify
     applies the larger. So next to a quantity card that already saves, the
     add-on only saves what is left: max(0, off - the card's saving). */
  function initCombo(root) {
    $$('[data-combo]', root).forEach(function (box) {
      if (box.__init) return; box.__init = true;
      var data = {};
      try { data = JSON.parse(($('[data-combo-data]', box) || {}).textContent || '{}'); } catch (e) {}
      var variants = data.variants || {};
      var off = +data.off || 0;
      var base = +data.base || 0;
      var tierSaving = 0;
      var check = $('[data-combo-check]', box);
      var radios = $$('[data-combo-variant]', box);
      var card = $('.combo__card', box);
      var status = $('[data-combo-status]', box);
      var badge = $('[data-combo-badge]', box);
      var badgeText = box.getAttribute('data-badge') || '';
      var describedBy = check.getAttribute('aria-describedby');
      var qb = $('[data-qbreaks]');
      if (qb && typeof qb.__total === 'number' && !isNaN(qb.__total)) { base = qb.__total; tierSaving = qb.__saving || 0; }

      function chosen() {
        for (var i = 0; i < radios.length; i++) if (radios[i].checked && !radios[i].disabled) return radios[i].value;
        return radios.length ? null : Object.keys(variants)[0] || null;
      }
      function saving() { return Math.max(0, off - tierSaving); }
      function addonPrice() {
        var d = variants[chosen()];
        return d ? Math.max(0, d.price - saving()) : 0;
      }
      function total() { return base + (check.checked ? addonPrice() : 0); }
      function label() {
        setShipLine(total());
        var sum = formatMoney(total());
        $$('[data-buy-buttons] button[type="submit"], [data-sticky-submit]', document).forEach(function (btn) {
          if (!btn.disabled) btn.textContent = T.strings.addToCart + ' – ' + sum;
        });
        card.classList.toggle('is-selected', check.checked);
      }
      /* Screen readers hear the new total, which the button text alone would not say. */
      function announce() {
        if (!status) return;
        var d = variants[chosen()];
        var item = (data.product || '') + (d && radios.length ? ' (' + d.title + ')' : '');
        var msg = box.getAttribute(check.checked ? 'data-msg-on' : 'data-msg-off') || '';
        status.textContent = msg.replace('[item]', item).replace('[total]', formatMoney(total()));
      }
      function paint() {
        var d = variants[chosen()]; if (!d) return;
        var s = saving();
        var name = $('[data-combo-colour]', box), now = $('[data-combo-now]', box);
        var was = $('[data-combo-was]', box), wasWrap = $('[data-combo-was-wrap]', box);
        var img = $('.combo__img', box);
        if (name) name.textContent = d.title;
        if (now) now.textContent = formatMoney(addonPrice());
        if (was) was.textContent = formatMoney(d.price);
        if (wasWrap) wasWrap.hidden = s <= 0;
        if (badge) {
          badge.hidden = s <= 0;
          badge.textContent = badgeText.replace('[besparing]', formatMoney(s));
          if (describedBy) {
            if (s > 0) check.setAttribute('aria-describedby', describedBy);
            else check.removeAttribute('aria-describedby');
          }
        }
        if (img && d.img && img.getAttribute('src') !== d.img) { img.removeAttribute('srcset'); img.src = d.img; }
      }
      box.__comboItem = function () { return check.checked ? chosen() : null; };
      box.__addonItems = function () { var id = box.__comboItem(); return id ? [{ id: id, quantity: 1 }] : []; };
      on(check, 'change', function () { label(); announce(); });
      /* click, not change: tapping the colour already picked must tick the box too
         (arrow keys in the group fire click as well). */
      radios.forEach(function (r) {
        on(r, 'click', function () {
          var was = check.checked;
          check.checked = true; paint(); label();
          if (!was || r.value !== box.__last) announce();
          box.__last = r.value;
        });
      });
      function onVariant(e) {
        if (!box.isConnected) { document.removeEventListener('nz:variant-change', onVariant); return; }
        var v = e.detail && e.detail.variant; if (!v) return;
        if (!qb) base = +v.price || base;
        if (check.checked) label();
      }
      function onBase(e) {
        if (!box.isConnected) { document.removeEventListener('nz:base-total', onBase); return; }
        var c = e.detail ? +e.detail.cents : NaN; if (isNaN(c)) return;
        base = c; tierSaving = +e.detail.saving || 0;
        paint();
        if (check.checked) { label(); announce(); }
      }
      document.addEventListener('nz:variant-change', onVariant);
      document.addEventListener('nz:base-total', onBase);
      /* A reload can bring the box back ticked (form state restore). */
      box.__last = chosen();
      paint();
      if (check.checked) label();
    });
  }

  /* ---------------- Set add-ons (a second set, a matching pillowcase) ---------------- */
  /* Both ride along with the main button; the buttons show the new total. The
     pillowcase follows the chosen set's colour and hides when there is none. */
  function initSetExtras(root) {
    $$('[data-set-extras]', root).forEach(function (box) {
      if (box.__init) return; box.__init = true;
      var data = {};
      try { data = JSON.parse(($('[data-setx-data]', box) || {}).textContent || '{}'); } catch (e) {}
      var map = data.variants || {};
      var current = String(data.variant || '');
      var setCheck = $('[data-setx-check="set"]', box), pilCheck = $('[data-setx-check="pillow"]', box);
      var pilCard = $('[data-setx-card="pillow"]', box);
      var status = $('[data-setx-status]', box);
      var label = box.getAttribute('data-pillow-label') || '';
      function v() { return map[current] || {}; }
      function pillow() { var p = v().pillow; return p && p.ok ? p : null; }
      function qty() { var q = $('[data-buy-buttons] input[name="quantity"]'); return (q && parseInt(q.value, 10)) || 1; }
      function total() {
        var t = (v().price || 0) * qty();
        if (setCheck && setCheck.checked) t += v().price || 0;
        if (pilCheck && pilCheck.checked && pillow()) t += pillow().price;
        return t;
      }
      function relabel() {
        setShipLine(total());
        var sum = formatMoney(total());
        $$('[data-buy-buttons] button[type="submit"], [data-sticky-submit]', document).forEach(function (btn) {
          if (!btn.disabled) btn.textContent = T.strings.addToCart + ' \u2013 ' + sum;
        });
        $$('[data-setx-card]', box).forEach(function (c) {
          var ch = $('[data-setx-check]', c); c.classList.toggle('is-selected', !!(ch && ch.checked));
        });
      }
      function announce(which, on) {
        if (!status) return;
        var name = which === 'set' ? ($('.combo__title', $('[data-setx-card="set"]', box)) || {}).textContent : ($('[data-setx-title="pillow"]', box) || {}).textContent;
        var msg = box.getAttribute(on ? 'data-msg-on' : 'data-msg-off') || '';
        status.textContent = msg.replace('[item]', (name || '').trim().toLowerCase()).replace('[total]', formatMoney(total()));
      }
      function paint() {
        var d = v();
        var sp = $('[data-setx-price="set"]', box); if (sp && d.price) sp.textContent = formatMoney(d.price);
        var si = $('[data-setx-card="set"] .combo__img', box);
        if (si && d.img && si.getAttribute('src') !== d.img) { si.removeAttribute('srcset'); si.src = d.img; }
        var p = pillow();
        if (pilCard) {
          pilCard.hidden = !p;
          if (!p && pilCheck) pilCheck.checked = false;
          if (p) {
            var t = $('[data-setx-title="pillow"]', box); if (t) t.textContent = label.replace('[kleur]', p.title);
            var pp = $('[data-setx-price="pillow"]', box); if (pp) pp.textContent = formatMoney(p.price);
            var pi = $('.combo__img', pilCard);
            if (pi && p.img && pi.getAttribute('src') !== p.img) { pi.removeAttribute('srcset'); pi.src = p.img; }
          }
        }
      }
      box.__addonItems = function () {
        var out = [];
        if (setCheck && setCheck.checked && current) out.push({ id: current, quantity: 1 });
        if (pilCheck && pilCheck.checked && pillow()) out.push({ id: pillow().id, quantity: 1 });
        return out;
      };
      on(setCheck, 'change', function () { relabel(); announce('set', setCheck.checked); });
      on(pilCheck, 'change', function () { relabel(); announce('pillow', pilCheck.checked); });
      function onVariant(e) {
        if (!box.isConnected) { document.removeEventListener('nz:variant-change', onVariant); return; }
        var nv = e.detail && e.detail.variant; if (!nv) return;
        current = String(nv.id);
        paint();
        if ((setCheck && setCheck.checked) || (pilCheck && pilCheck.checked)) relabel();
      }
      document.addEventListener('nz:variant-change', onVariant);
      paint();
      if ((setCheck && setCheck.checked) || (pilCheck && pilCheck.checked)) relabel();
    });
  }

  /* ---------------- Proven-benefits list ---------------- */
  /* One point is always open. A mouse opens a point by moving onto it (after a
     short pause, so sweeping across the list does not flicker); a tap, click or
     Enter/Space opens it too. Only real pointer movement counts: when a point
     opens, the list shifts under a still cursor, and that must not open another. */
  function initFacc(root) {
    $$('[data-facc]', root).forEach(function (box) {
      if (box.__init) return; box.__init = true;
      var items = $$('[data-facc-item]', box);
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      var timer = null;
      var anchor = null; /* where the pointer was when a point last opened */

      function activate(item) {
        items.forEach(function (it) {
          var open = it === item;
          it.classList.toggle('is-active', open);
          var t = $('[data-facc-trigger]', it);
          if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      box.__faccActivate = activate;

      items.forEach(function (it) {
        var t = $('[data-facc-trigger]', it);
        if (!t) return;
        on(t, 'click', function (e) { window.clearTimeout(timer); anchor = { x: e.clientX, y: e.clientY }; activate(it); });
        on(t, 'pointermove', function (e) {
          if (e.pointerType !== 'mouse' || !fine.matches) return;
          if (!e.movementX && !e.movementY) return;
          /* After a point opens the list re-centres under the pointer: ignore
             small moves near that spot, so a hand tremor does not open the next. */
          if (anchor && Math.abs(e.clientX - anchor.x) + Math.abs(e.clientY - anchor.y) < 10) return;
          anchor = null;
          if (it.classList.contains('is-active')) return;
          window.clearTimeout(timer);
          var x = e.clientX, y = e.clientY;
          timer = window.setTimeout(function () { anchor = { x: x, y: y }; activate(it); }, 120);
        });
        on(t, 'pointerleave', function () { window.clearTimeout(timer); });
      });
    });
  }
  /* Theme editor: selecting a point's block opens it. */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest && e.target.closest('[data-facc-item]');
    var box = item && item.closest('[data-facc]');
    if (box && box.__faccActivate) box.__faccActivate(item);
  });

  /* ---------------- Footer folds (phone) ---------------- */
  function initFooterFolds(root) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    $$('[data-footer-fold]', root).forEach(function (d) {
      if (d.__init) return; d.__init = true;
      if (!d.hasAttribute('data-footer-keep')) d.removeAttribute('open');
    });
  }

  /* A select that should apply as soon as it changes (country picker). */
  function initAutosubmit(root) {
    $$('[data-autosubmit]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      on(el, 'change', function () { if (el.form) el.form.submit(); });
    });
  }

  /* ---------------- Image card carousel ---------------- */
  function initCards(root) {
    $$('[data-cards-track]', root).forEach(function (track) {
      if (track.__init) return; track.__init = true;
      var row = track.parentElement;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      $$('[data-cards-arrow]', row).forEach(function (btn) {
        on(btn, 'click', function () {
          var dir = btn.getAttribute('data-cards-arrow') === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * step(), behavior: RM.matches ? 'auto' : 'smooth' });
        });
      });

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        setArrowState($('[data-cards-arrow="prev"]', row), $('[data-cards-arrow="next"]', row),
          track.scrollLeft <= 2, track.scrollLeft >= max);
      }
      on(track, 'scroll', sync);
      on(window, 'resize', sync);
      sync();
    });
  }

  /* ---------------- Cookie choices ---------------- */
  /* The footer button reopens Shopify's cookie preferences, when the banner's API is there. */
  function initCookieSettings() {
    var b = $('[data-cookie-settings]');
    if (!b || b.__init) return; b.__init = true;
    function ready() { return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'; }
    function reveal() { if (ready()) b.hidden = false; }
    reveal();
    window.setTimeout(reveal, 2500);
    document.addEventListener('visitorConsentCollected', reveal);
    on(b, 'click', function () { if (ready()) window.privacyBanner.showPreferences(); });
  }

  /* ---------------- Sticky add-to-cart bar ---------------- */
  function initStickyBar() {
    var bar = $('[data-sticky-bar]');
    if (!bar || bar.__init) return; bar.__init = true;
    var anchor = $('[data-buy-buttons]') || $('[data-sticky-anchor]');
    if (!anchor) return;
    /* Shown once the buy button has scrolled up out of view, whatever way the page
       got there (scrolling, an anchor jump, the End key, a restored position). */
    var ticking = false;
    function update() {
      ticking = false;
      if (!anchor.isConnected) anchor = $('[data-buy-buttons]') || $('[data-sticky-anchor]');
      if (!anchor) return;
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
    var title = $('.sticky-bar__title', bar);
    var baseTitle = title ? title.textContent : '';
    document.addEventListener('nz:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (title && v && v.options && v.options.length && v.options[0] && v.options[0] !== 'Default Title') {
        title.textContent = baseTitle.split(' \u2013 ')[0] + ' \u2013 ' + v.options.join(' / ');
      }
    });

    on($('[data-sticky-submit]', bar), 'click', function (e) {
      e.preventDefault();
      var form = $('[data-product-form] form') || $('form[action*="/cart/add"]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------------- Scroller nav arrows ---------------- */
  function initScrollers(root) {
    $$('[data-scroller]', root).forEach(function (s) {
      if (s.__init) return; s.__init = true;
      var track = $('.scroller__track', s);
      if (!track) return;
      var navs = $$('[data-scroller-nav]', s);
      /* One click moves a full page of cards; the arrows grey out at either end. */
      function page() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return track.clientWidth + gap;
      }
      function setNav() {
        var max = track.scrollWidth - track.clientWidth - 2;
        navs.forEach(function (btn) {
          var prev = btn.getAttribute('data-scroller-nav') === 'prev';
          var off = prev ? track.scrollLeft <= 2 : track.scrollLeft >= max;
          if (off && btn === document.activeElement) {
            var other = navs.filter(function (b) { return b !== btn; })[0];
            if (other) { other.disabled = false; other.focus({ preventScroll: true }); }
          }
          btn.disabled = off;
        });
      }
      navs.forEach(function (btn) {
        on(btn, 'click', function () {
          var dir = btn.getAttribute('data-scroller-nav') === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * page(), behavior: RM.matches ? 'auto' : 'smooth' });
        });
      });
      var queued = false;
      on(track, 'scroll', function () {
        if (queued) return; queued = true;
        window.requestAnimationFrame(function () { queued = false; setNav(); });
      });
      on(window, 'resize', setNav);
      setNav();
    });
  }

  /* ---------------- Review list: sort, paging, helpful votes ---------------- */
  function initReviews(root) {
    $$('[data-reviews-list]', root).forEach(function (list) {
      if (list.__init) return; list.__init = true;
      var PAGE = 5;
      var items = $$('.review', list);
      var shown = PAGE;

      function paint() {
        items.forEach(function (li, i) {
          if (i < shown) li.removeAttribute('hidden');
          else li.setAttribute('hidden', '');
        });
        var more = $('[data-reviews-more]', list.closest('.reviews'));
        if (more) more.hidden = shown >= items.length;
      }

      function num(li, attr) { return parseFloat(li.getAttribute(attr)) || 0; }

      var select = $('[data-reviews-sort]', list.closest('.reviews'));
      on(select, 'change', function () {
        var mode = select.value;
        items.sort(function (a, b) {
          if (mode === 'helpful') return num(b, 'data-helpful') - num(a, 'data-helpful');
          if (mode === 'highest') return num(b, 'data-rating') - num(a, 'data-rating');
          if (mode === 'lowest') return num(a, 'data-rating') - num(b, 'data-rating');
          return num(a, 'data-order') - num(b, 'data-order');
        });
        items.forEach(function (li) { list.appendChild(li); });
        shown = PAGE;
        paint();
      });

      on($('[data-reviews-more]', list.closest('.reviews')), 'click', function () {
        shown += PAGE;
        paint();
      });

      list.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-vote]');
        if (!btn) return;
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        var counter = $('span', btn);
        var n = parseInt(counter.textContent, 10) || 0;
        counter.textContent = pressed ? n - 1 : n + 1;
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        var sibling = $$('[data-vote]', btn.parentElement).filter(function (b) { return b !== btn; })[0];
        if (sibling && sibling.getAttribute('aria-pressed') === 'true') {
          var sc = $('span', sibling);
          sc.textContent = (parseInt(sc.textContent, 10) || 1) - 1;
          sibling.setAttribute('aria-pressed', 'false');
        }
      });

      paint();
    });
  }

  /* ---------------- Init ---------------- */
  function initAll(root) {
    root = root || document;
    initQty(root);
    initVariantPicker(root);
    initGallery(root);
    initTabs(root);
    initRotator(root);
    initAnnouncement(root);
    initReviewStrip(root);
    initScrollers(root);
    initCards(root);
    initToc(root);
    initFooterFolds(root);
    initFacc(root);
    initQtyBreaks(root);
    initCombo(root);
    initSetExtras(root);
    initProgress(root);
    initTabMore(root);
    initAutosubmit(root);
    initReviews(root);
    initStickyBar();
    initCookieSettings();
  }

  /* Restore first: on the page that starts a market switch, restoring after
     lockMarket() would clear the hash it just saved for the reloaded page. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { restoreMarketHash(); lockMarket(); initAll(); });
  else { restoreMarketHash(); lockMarket(); initAll(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.NachtzijdeCart = Cart;
  window.NachtzijdeMoney = formatMoney;
})();
